/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiKeycloakGetMemberRegistrationSequenceGet$Plain$Params {
  Authorization?: string;
}

export function apiKeycloakGetMemberRegistrationSequenceGet$Plain(http: HttpClient, rootUrl: string, params?: ApiKeycloakGetMemberRegistrationSequenceGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakGetMemberRegistrationSequenceGet$Plain.PATH, 'get');
  if (params) {
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiKeycloakGetMemberRegistrationSequenceGet$Plain.PATH = '/api/keycloak/GetMemberRegistrationSequence';
